/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable no-nested-ternary */
import type {
  ApplyChannelData,
  OrderCheck, OrderQueryRealTime, RemoteContract, SubmitApplyResultData,
} from '@/api/apply-product/types';
import type { ContractItem } from '@/ContractConfig';
import CreatedIframe from '@/mixins/create-iframe';
import { Popup } from 'vant';
import { Tabs, TabItem } from '@hb/coffee';
import {
  Component, Mixins, Model, Prop, Watch,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const style = require('./index.module.scss') as Dictionary;

const ApplyProductStore = namespace('applyProduct');

@Component({
  name: 'ForcedPopup',
})
export default class ForcedPopup extends Mixins(CreatedIframe) {
  @ApplyProductStore.State contracts!: (ContractItem | RemoteContract)[];

  @ApplyProductStore.State submitResult!: SubmitApplyResultData | undefined;

  @ApplyProductStore.State queryRealTimeStatus!: OrderQueryRealTime

  @ApplyProductStore.State orderCheckListDxm!: OrderCheck

  @ApplyProductStore.State channel!: ApplyChannelData | undefined;

  @ApplyProductStore.Action $updateState!: (data: Dictionary) => void;

  @Model('change', {
    type: Boolean,
  })
  private isVisibleForcePopup!: boolean

  @Prop({
    default: '放弃本次提现',
  })
  private cancelText!: string

  @Prop({
    default: '确认提现',
  })
  private confirmText!: string

 private currentDisplayIndex = 0

 private currentScrollHeight = 0

  private currentTabBaroffsetTop = 0

 @Watch('isVisibleForcePopup', { immediate: true })
  private onChangeVisible(visiblePopup: boolean) {
    if (visiblePopup) {
      // 曝光埋点
      this.$ubtModuleExpose(
        'finance_withdrawalApplicationPage_agreementMandatoryDisplay',
        'commodityId',
       // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
       (this.channel && `${this.channel.productId}`)!,
       'source',
       this.buriedPointSource(),
      );

      this.$nextTick(() => {
        const currentScrollEle = document.getElementById('currentScrollDom') as HTMLElement;
        const currentTabsEle = document.getElementById('currentTabs') as HTMLElement;
        currentScrollEle.addEventListener('scroll', () => {
          this.currentScrollHeight = currentScrollEle.scrollTop;
        }, { passive: true });
        this.currentTabBaroffsetTop = currentTabsEle.offsetTop - 53;
        this.createdIframe(
           // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
           this.contracts[0].url!,
           'currentIframeEle',
           'iframePopup',
           style.iframeStyle as string,
        );
      });
    }
  }

 private get getScrollVaule() {
   return (this.currentScrollHeight > this.currentTabBaroffsetTop)
   && this.isVisibleOutstandingOrdersPopup;
 }

 // 度小满-是否显示未完成订单弹窗
 private get isVisibleOutstandingOrdersPopup(): boolean {
   return this.orderCheckListDxm && this.orderCheckListDxm.popWindow;
 }

 // 度小满-是否显示双按钮
 private get isVisibleDoubleBtn(): boolean {
   return this.isSecondForcedContractAdd || this.isVisibleOutstandingOrdersPopup;
 }

 // 度小满-是否显示第一次协议弹窗
 private get isFirstForcedContractAdd() {
   return !(this.submitResult
    && this.submitResult.applyOrderCheckVo && this.submitResult.applyOrderCheckVo.contractAdd);
 }

 // 度小满-第二次协议弹窗
 private get isSecondForcedContractAdd(): boolean {
   return this.queryRealTimeStatus && this.queryRealTimeStatus.contractAdd;
 }

 // 显示格式化的金额
 private get showAmount(): string {
   return String(this.orderCheckListDxm && this.orderCheckListDxm.amount).replace(/(\d)(?=(?:\d{3})+($|\.))/g, '$1,');
 }

 // 多协议切换tab
 private onChangeTabs(index: number) {
   this.currentDisplayIndex = index;
   this.createdIframe(
     // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
     this.contracts[index].url!,
     'currentIframeEle',
     'iframePopup',
     style.iframeStyle as string,
   );
 }

 private showContractName(name: string): string {
   if (!name) return '';
   const contractName = name.replace(/[《》]/g, '');
   if (contractName.length > 9) {
     return `${contractName.substr(0, 9)}...`;
   }
   return contractName;
 }

 // 隐藏弹窗
 private hiddenPopup() {
   this.$emit('change', false);
 }

 // 关闭按钮弹窗
 private onClosePopup() {
   this.$updateState({ checkType: '', checkId: '' });
   this.hiddenPopup();
 }

 // 确认提现
 private onOrderApply() {
   this.$ubtPageButton(
     'finance_withdrawalApplicationPage_secondConfirm',
     'commodityId',
   (this.channel && `${this.channel.productId}`)!,
   'source',
   this.buriedPointSource(),
   );
   this.hiddenPopup();
   const contractAdd = (this.queryRealTimeStatus && this.queryRealTimeStatus.contractAdd) || '';
   if (this.isVisibleOutstandingOrdersPopup || contractAdd) {
     this.$emit('confirmApplyDxm');
     return;
   }

   if (this.isFirstForcedContractAdd) {
     // 第一次协议
     this.$emit('confirmApply');
   }
 }

 // 度小满-终止提现
 private onCancelApply() {
   this.$ubtPageButton(
     'finance_withdrawalApplicationPage_giveUp',
     'commodityId',
     (this.channel && `${this.channel.productId}`)!,
     'source',
     this.isSecondForcedContractAdd ? 'dxmLoanApplication' : (this.isVisibleOutstandingOrdersPopup ? 'dxmLoanInterruptProcess' : ''),
   );
   this.onClosePopup();
   this.$emit('cancel');
 }

 // 埋点来源
 private buriedPointSource(): string {
   const source = this.isVisibleOutstandingOrdersPopup
     ? 'dxmLoanInterruptProcess'
     : (this.isFirstForcedContractAdd
       ? 'dxmAuthentication'
       : (this.isSecondForcedContractAdd ? 'dxmLoanApplication' : ''));
   return source;
 }

 private render() {
   return (
      <div class={style.ForcedPopup}>
        <Popup
          class={style.visibleForcePopup}
          v-model={this.isVisibleForcePopup}
          position='bottom'
          closeOnClickOverlay={false}
        >
          <section class={style.sectionContent}>
            <div class={style.content}>
              <div class={style.title}>
                <span>{this.isSecondForcedContractAdd
                  ? '仅差一步，您有借款协议待确认'
                  : (this.isVisibleOutstandingOrdersPopup ? '仅差一步，您是否要继续提现?' : '确认提现')}</span>
                <span
                  class={style.closed}
                  v-show={!this.isVisibleDoubleBtn}
                  onClick={this.onClosePopup.bind(this)}>
                </span>
              </div>
              <div class={style.contentMain} id='currentScrollDom'>
                <div class={style.amount} v-show={this.isVisibleOutstandingOrdersPopup}>
                  <div class={style.titleTips}>
                    <span>提现金额</span>
                  </div>
                  {
                    this.showAmount
                    && <div class={style.aomuntCount}>
                    <span>¥{this.showAmount}</span>
                  </div>
                  }
                </div>
                <div
                  id='currentTabs'
                  class={[style.tabs]}
                  v-show={this.contracts && this.contracts.length > 1}>
                  <div class={[
                    style.tabsContent,
                    this.getScrollVaule && style.tabsFixed,
                    (!this.isVisibleOutstandingOrdersPopup) && style.popUpDialog,
                  ]}>
                      <Tabs
                        size="small"
                        scrollable={true}
                        activeIndex={this.currentDisplayIndex}
                        onChange={this.onChangeTabs.bind(this)}
                      >
                        {this.contracts.map((item, index) => (
                          <TabItem
                            key={index}
                            title={this.showContractName(item.name)}
                            name={index}
                          />
                        ))}
                      </Tabs>
                  </div>
                </div>
                <div id='iframePopup' class={style.iframeFather}>

                </div>
              </div>
            </div>
            <footer class={style.footer}>
              {
                this.isVisibleDoubleBtn && <div
                  class={[
                    style.cancelText,
                    this.isVisibleDoubleBtn && style.footerBtn,
                  ]}
                  onClick={this.onCancelApply.bind(this)}>
                <span>{this.cancelText}</span>
              </div>
              }
              <div
                class={[style.confirmText, this.isVisibleDoubleBtn && style.footerBtn]}
                onClick={this.onOrderApply.bind(this)}>
                <span>{this.confirmText}</span>
              </div>
            </footer>
          </section>
        </Popup>
      </div>
   );
 }
}
